import IcArrowRight from "@/assets/common/ic_arrow_right.svg?react";

interface CellProps {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  value?: React.ReactNode;
  arrow?: boolean;
  valueAlign?: "left" | "right";
  onClick?: () => void;
  disabled?: boolean;
}

function Cell(props: CellProps) {
  const {
    icon,
    title,
    value,
    arrow = true,
    valueAlign = "right",
    onClick,
    disabled = false,
  } = props;
  const handleClick = () => {
    if (disabled) return;
    onClick?.();
  };
  return (
    <div
      className="flex items-center justify-between p-x-4 active:opacity-50"
      onClick={handleClick}
    >
      {icon && <div className="">{icon}</div>}
      <div className="flex items-center justify-center p-x-4 p-y-3.75">
        {title}
      </div>
      <div
        className={`flex-1 flex ${
          valueAlign === "left" ? "justify-start" : "justify-end"
        }`}
      >
        {value}
      </div>
      {!disabled && arrow && <IcArrowRight className="w-4 h-4 m-l-2" />}
    </div>
  );
}
export default Cell;
